/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Tour request bizo
 */

import { Bizo, autoclass } from '../../shared/bizos/base'
import Building from '../../shared/bizos/building'

const TourRequest = autoclass('TourRequest', class TourRequest extends Bizo {}, {
  building: { name: 'building', type: Building },
  buildingId: 'building_id',
  cancellationReason: 'cancellation_reason',
  contactPreferenceEnum: 'contact_preference',
  email: 'email',
  floorplanId: 'floorplan_id',
  message: 'message',
  moveIn: 'move_in',
  name: 'name',
  phone: 'phone',
  startOn: 'start_on',
  status: 'status',
  tenantId: 'tenant_id',
  tourRequestId: 'tour_request_id',
  timezone: 'tz',
  type: 'type',
})

const TourRequestResult = autoclass('TourRequestResult', class TourRequestResult extends Bizo {}, {
  messageId: 'message_id',
  tourRequests: {
    isArray: true,
    name: 'tour_requests',
    type: TourRequest,
  },
})

const TourRequestResponseTransformer = {
  fromJS: (data) => {
    if (
      data &&
      typeof data === 'object' &&
      Object.prototype.hasOwnProperty.call(data, 'tour_requests')
    ) {
      return new TourRequestResult(data)
    }
    return new TourRequest(data)
  },
}

export default TourRequestResponseTransformer
